import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=bcecc4ea"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcecc4ea')) {
      api.createRecord('bcecc4ea', component.options)
    } else {
      api.reload('bcecc4ea', component.options)
    }
    module.hot.accept("./Cross.vue?vue&type=template&id=bcecc4ea", function () {
      api.rerender('bcecc4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Cross.vue"
export default component.exports